import { cn } from "../../../shared/landing-page/utils";
import "./separator.scss";

interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: "horizontal" | "vertical";
}

export const Separator: React.FC<SeparatorProps> = ({
  className,
  orientation = "horizontal",
  ...props
}) => {
  const orientationClass = orientation === "horizontal" ? "Separator-horizontal" : "Separator-vertical";
  
  return (
    <div
      className={cn("Separator", orientationClass, className)}
      {...props}
    />
  );
};
